/**
 * RESPONSIBILITY: one labelled fact about an event.
 *
 * A pair and not a fixed set of fields, because every church says a different four:
 * when, where, cost, who it is for, which campus, what to bring. Naming them in the
 * annotation would mean a deploy to add "Childcare".
 */
import { Row, Text } from '@framework/core/decorators';

@Row()
export class FactRow {
  @Text({ label: 'Label', maxLength: 120, description: 'e.g. When, Where, Cost.' })
  label!: string;

  @Text({ label: 'Value', maxLength: 300 })
  value!: string;
}
